import { Form } from "antd";
import { rules } from "./rules";



export default function CustomFormItem(props) {
    return (  
        <Form.Item  {...props} rules={rules[props.rules]}/>
    );
}





